.my-order-wrap {
  --color-primary: #0099e6;
  --color-gray: #5f7195;
  --border-color: #262d40;
  --bar-height:40px;
}

.my-order-wrap {
  margin: 0 0 2.5rem;
  position: relative;
  :global {
    .nav-tabs {
      padding-left: 1px;
      height: var(--bar-height);
      border-bottom: 1px solid var(--border-color);
      .nav-link {
        height: 100%;
        border-radius: 0;
        border-width: 0 1px 0 0;
        border-color: var(--border-color);
        border-style: solid;
        background: transparent;
        color: var(--color-gray);
        font-weight: 400;
        transition: all 0.3s;
        &:hover,
        &.active {
          background: #090d1a;
          color: var(--color-primary);
        }
      }
    }
    .tab-content {
      padding-top: var(--bar-height);
    }
  }
  .order-operator {
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height:var(--bar-height);
    position: absolute;
    width: 100%;
    top: var(--bar-height);
    border-bottom: 1px solid var(--border-color);
  }
}

.check-switch {
  display: flex;
  align-items: center;
  .check-switch-title {
    color: var(--color-gray);
    padding-right: 5px;
  }
  .toggle {
    cursor: pointer;
    border: none;
    background: #090d1a;
    border-radius: 1rem;
    color: #fff;
    display: block;
    position: relative;
    transition: background 120ms;
    width: 2rem;
    height: 0.875rem;
    margin: 0 1rem 0 0.5rem;
    padding: 0;
    &:before {
      content: '';
      display: block;
      text-align: right;
    }
    &.active {
      background: var(--color-primary);
      &:before {
        text-align: left;
      }
    }
    .handle {
      background: #212a45;
      border-radius: 50%;
      display: block;
      height: 1rem;
      width: 1rem;
      left: -10%;
      margin-top: -0.5rem;
      position: absolute;
      top: 50%;
      transition: all 120ms;
    }
    &.active .handle {
      left: 70%;
      background: #ffffff;
    }
  }
}

.btn-connect {
  background: none;
  border: none;
  color: var(--color-primary);
  transition: all 0.3s;
  border-bottom: 1px solid rgba(0, 153, 230, 0.5);
  padding: 0;
  &:hover {
    color: #ffffff;
    border-bottom: 1px solid #ffffff;
  }
}

.btn-cancel {
  background: #1a2239;
  border-radius: 0.5rem;
  font-weight: 400;
  color: var(--color-gray);
  border: none;
  min-width: 4rem;
  height: 1.5rem;
  padding: 0 8px;
  transition: all 0.3s;
  &:hover {
    color: var(--color-primary);
    background: #212a45;
  }
  &:disabled {
    color: var(--color-gray);
    background: #212a45;
  }
  :global {
    .spinner-border {
      width: 0.75rem;
      height: 0.75rem;
      margin-left: 5px;
      color: var(--color-primary) !important;
    }
  }
}

.order-table {
  border-bottom: none;
  th,
  td {
    text-align: left;
    border-color: var(--border-color);
    font-weight: 400;
    color: var(--color-gray);
    white-space: nowrap;
    &:last-child {
      text-align: right;
      width: 6.25rem;
    }
  }
  thead th {
    vertical-align: middle;
  }
  tbody tr {
    &:hover td {
      color: var(--color-gray);
    }
    &:last-child td {
      border: none;
    }
  }
}

@media screen and (min-width: 768px) {
  .btn-cancel:hover {
    color: #fff;
  }
  .my-order-wrap {
    .order-operator {
      width: auto;
      padding: 0;
      right: 0;
      top: 0;
      justify-content: flex-end;
      :global{
        .btn-cancel {
          border-width: 0 0 0 1px;
          border-color: var(--border-color);
          border-style: solid;
          background: transparent;
          height: 100%;
          color: var(--color-gray);
          font-weight: 400;
          transition: all 0.3s;
          border-radius: 0;
          padding: 0 1rem;
          &:hover {
            background: #090d1a;
            color: #fff;
          }
        }
      }
    }
    :global {
      .tab-content {
        padding-top: 0;
      }
      .nav-tabs .nav-link {
        width: 9.375rem;
        &:hover,
        &.active {
          color: #ffffff;
        }
      }
    }
  }
}